import dom from '../../utils/dom';


class ZoneGroupSelector {
  /**
   * @param {HTMLElement} el
   * @param {function} onChangeCallback
   */
  constructor(el, onChangeCallback) {
    this.el = el;
    this.onChangeCallback = onChangeCallback;

    /** @type {HTMLSelectElement} */
    this.select = dom.findFrom(el, 'select');

    this.items = [...this.select.options]
      .filter(option => !!option.value)
      .map(option => ({
        id: option.value,
        isAvailable: !option.disabled,
      }));

    this.select.addEventListener('change', this.onSelectChange);
  }

  get isSingleZoneGroup() {
    return this.items.length === 1;
  }

  getZoneGroupIds() {
    return this.items.map(el => el.id);
  }

  selectZoneGroup(id) {
    this.select.value = id || '';
  }

  onSelectChange = () => {
    this.onChangeCallback(this.getZoneGroupId());
  }

  getZoneGroupId() {
    return this.select.value;
  }

  destroy() {
    this.select.removeEventListener('change', this.onSelectChange);
    this.onChangeCallback = null;
  }
}


export default ZoneGroupSelector;



// WEBPACK FOOTER //
// ./src/events/detail/ZoneGroupSelector.js